import { isMobile } from './mobile';

const storePageOffsetY = () => {
    if (typeof Storage !== 'undefined' && window.pageYOffset !== 0) {
        window.sessionStorage.setItem('pageOffsetY', `${window.pageYOffset}`);
    }
};

const resetPageOffsetY = () => {
    if (typeof Storage !== 'undefined') {
        window.sessionStorage.setItem('pageOffsetY', '0');
    }
};

export const enableBodyScroll = () => {
    if (isMobile()) {
        document.body.classList.remove('no-scroll');
        window.scrollTo(0, Number.parseInt(window.sessionStorage.getItem('pageOffsetY') ?? '0')); // Thanks iOS
        resetPageOffsetY();
    }
};

export const disableBodyScroll = () => {
    if (isMobile()) {
        storePageOffsetY();
        document.body.classList.add('no-scroll');
        window.scrollTo(0, 1); // iOS needs to scroll to top when overlay opens
    }
};
